import { Line } from 'react-chartjs-2';
import { useState } from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler } from 'chart.js';
import { Row, Col, Button } from 'react-bootstrap';
import { getAppUserStats } from '../../../services/reportService';
import { useEffect } from 'react';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler);

// Helper: format "YYYY-MM" to "Month YYYY"
function formatMonthYear(yyyymm) {
    const [year, month] = yyyymm.split('-').map(Number);
    const date = new Date(year, month - 1);
    return date.toLocaleString('default', { month: 'long', year: 'numeric' });
}

// Helper: group array of registrations by "YYYY-MM"
function groupByMonth(registrations) {
    const groups = {};
    registrations.forEach(reg => {
        const date = new Date(reg.userRegistrationDate);
        if (isNaN(date)) return; // skip invalid dates
        const key = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
        if (!groups[key]) groups[key] = [];
        groups[key].push(reg);
    });
    return groups;
}

const AppUsersReport = () => {
    const [loading, setLoading] = useState(false);
    const [hasLoaded, setHasLoaded] = useState(false);
    const [appUserData, setAppUserData] = useState(null);
    const [graphData, setGraphData] = useState(null);

    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');


    const appUserStats = async () => {
        if (!dateFrom || !dateTo) {
            alert('Please select both From and To dates');
            return;
        }
        setHasLoaded(true);
        setLoading(true);
        try {
            const userData = await getAppUserStats(dateFrom, dateTo);
            setAppUserData(userData);
        } catch (err) {
            console.error('Error fetching app user report:', err);
            setAppUserData(null);
            setGraphData(null);
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!appUserData) return;

        const registrations = appUserData.userRegistrations || [];

        // Group registrations by month
        const grouped = groupByMonth(registrations);

        // Sort months ascending
        const sortedMonths = Object.keys(grouped).sort();

        const chartData = {
            labels: sortedMonths.map(formatMonthYear),
            datasets: [
                {
                    label: 'User Registrations',
                    data: sortedMonths.map(month => grouped[month].length),
                    fill: true,
                    borderColor: '#00c4c4',
                    tension: 0.2,
                }
            ]
        };

        setGraphData(chartData);
        setLoading(false);
    }, [appUserData]);

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            title: {
                display: true,
                text: '',
            },
            legend: {
                position: 'top',
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    stepSize: 1,            // force increments of 1
                    callback: function (value) {
                        // Only show whole numbers (no decimals)
                        if (Number.isInteger(value)) {
                            return value;
                        }
                        return null;
                    }
                }
            }
        }
    };

    return (
        <div className="appUsers component">
            <Row>
                <Col xs={12}>
                    <h3 className="text-center">App User Registrations</h3>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col xs={12} md={6}>
                    <label htmlFor="dateFrom" className="form-label">From:</label>
                    <input
                        type="date"
                        id="dateFrom"
                        className="form-control"
                        value={dateFrom}
                        onChange={e => setDateFrom(e.target.value)}
                    />
                </Col>
                <Col xs={12} md={6}>
                    <label htmlFor="dateTo" className="form-label">To:</label>
                    <input
                        type="date"
                        id="dateTo"
                        className="form-control"
                        value={dateTo}
                        onChange={e => setDateTo(e.target.value)}
                    />
                </Col>
                <Col xs={12} md={12} className="my-3 text-center">
                    <Button variant="primary" onClick={appUserStats} disabled={loading}>
                        Generate Report
                    </Button>
                </Col>
            </Row>

            <Row>
                <Col xs={12} style={{ width: '100%', height: '' }}>
                    {!hasLoaded ? null : loading ? (
                        <p className="text-center">Loading report...</p>
                    ) : (
                        graphData &&
                            <>
                                <Row>
                                    <Col xs={12}>
                                        <Line data={graphData} options={options} key={window.innerWidth} />
                                    </Col>
                                </Row>
                                <Row className="mt-3">
                                    <Col xs={12}>
                                        <p className="text-center">Users registered in time period: {appUserData.userRegistrations.length}</p>
                                    </Col>
                                </Row>
                                

                        </>
                    )}
                </Col>
            </Row>
        </div>
    );

};

export default AppUsersReport;
